<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{ $t("courseOption.createTheCourses") }}</span>
    </p>
    <el-form
      class="systemFont2 systemForm1"
      ref="newFormRef"
      :model="newForm"
      :rules="rules"
      label-width="80px"
      hide-required-asterisk
    >
      <el-row>
        <el-col :span="8" :offset="2">
          <!-- 课程类型 -->
          <el-form-item :label="$t('courseOption.courseType')" prop="courseType" style="text-align: left">
            <el-radio-group v-model="newForm.courseType" @change="changeCourseType">
              <el-radio label="0">{{ $t('courseOption.publicCourse') }}</el-radio>
              <el-radio label="1">{{ $t('courseOption.internalCourse') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('courseOption.field')" prop="field">
            <el-select
              v-model="newForm.field"
              @change="changeField"
              size="systemSelect3"
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'field'
                )"
                :key="item.codeKey"
                :label="`${item.codeKey} ${item.codeValueZh}`"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('courseOption.courseName')"
            prop="courseName"
          >
            <el-input
              v-model="newForm.courseName"
              size="reportContentInput"
              maxlength="125"
              :placeholder="$t('common.required')"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 目标学员 -->
          <el-form-item
            :label="$t('courseOption.targetStudents')"
            class="formItem"
          >
            <el-input
              v-model="newForm.targetStudents"
              type="textarea"
              size="reportLongContentInput"
              :rows="4"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <el-form-item :label="$t('courseOption.defaultForm')" prop="form">
            <el-select
              v-if="newForm.courseType === '1'"
              v-model="newForm.form"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                label="录播"
                value="02"
              >
              </el-option>
            </el-select>
            <el-select
              v-else
              v-model="newForm.form"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'form' && item.codeKey !== '02'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 课程时长想改成天+小时+分钟---zhc -->
          <el-form-item
            :label="$t('courseOption.defaultDuration')"
            :rules="minutesRule"
            prop="minutes"
          >
            <el-row>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="days"
                  size="systemSelect3"
                  style="width: calc(100% - 1.2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in dayList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.days") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="hours"
                  size="systemSelect3"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in hourList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.hours") }}
              </el-col>
              <el-col :span="8">
                <el-select
                  filterable
                  v-model="minutes"
                  size="systemSelect3"
                  style="width: calc(100% - 2rem);"
                  placeholder=""
                >
                  <el-option
                    v-for="item in durationList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                {{ $t("courseOption.minutes") }}
              </el-col>
            </el-row>
          </el-form-item>
          <!-- <el-time-picker
              v-model="newForm.duration"
              format="HH:mm"
              value-format="HH:mm"
              :picker-options="{
                selectableRange: '00:01:00 - 04:00:00'
              }"
              @focus="timePickerFocus"
              @blur="timePickerBlur"
              size="systemTimeSelect"
              style="width: 100%"
              arrow-control
              :placeholder="$t('common.selectDuration')">
            </el-time-picker> -->
          <el-form-item :label="$t('courseOption.certificate')">
            <el-input
              v-model="newForm.certificate"
              size="reportContentInput"
              maxlength="125"
            ></el-input>
          </el-form-item>
          <!-- 内部课程特有字段 -->
          <div v-if="newForm.courseType === '1'">
            <el-form-item :label="$t('courseOption.videoUrl')" prop="videoUrl">
              <el-input
                v-model="newForm.videoUrl"
                size="reportContentInput"
                maxlength="500"
                :placeholder="$t('common.required')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('courseOption.videoPassword')">
              <el-input
                v-model="newForm.videoPassword"
                size="reportContentInput"
                maxlength="50"
                :placeholder="$t('common.optional')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="height: 7.5px;"></div>
        </el-col>
        <el-col :span="8" :offset="4">
          <el-form-item label="">&nbsp;</el-form-item>
          <el-form-item :label="$t('courseOption.category')" prop="category">
            <el-select
              v-if="reloadCategoryFlag"
              v-model="newForm.category"
              size="systemSelect3"
              style="width: 100%"
              :placeholder="$t('common.pleaseSelect')"
            >
              <el-option
                v-for="item in newForm.field == ''
                  ? []
                  : selection.filter(
                      item =>
                        item.searchKey === 'category' &&
                        item.fatherSearchKey === 'field' &&
                        item.fatherCodeKey === newForm.field
                    )"
                :key="item.codeKey"
                :label="`${item.codeKey} ${item.codeValueZh}`"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('courseOption.courseNumber')"
            prop="courseNumber"
          >
            <el-input
              v-model="newForm.courseNumber"
              size="reportContentInput"
              @input="validateNumber"
              @blur="formatNumber"
              maxlength="2"
              :placeholder="$t('courseOption.pleaseEnterNumber')"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <!-- 资格要求 -->
          <el-form-item
            :label="$t('courseOption.qualificationRequirements')"
            class="formItem"
          >
            <el-input
              v-model="newForm.qualificationRequirements"
              type="textarea"
              size="reportLongContentInput"
              :rows="4"
              maxlength="600"
            ></el-input>
          </el-form-item>
          <div style="height: 7.5px;"></div>
          <el-form-item :label="$t('courseOption.classLanguage')">
            <el-select
              v-model="newForm.classLanguage"
              size="systemSelect3"
              style="width: 100%"
              placeholder=""
            >
              <el-option
                v-for="item in selection.filter(
                  item => item.searchKey === 'languages'
                )"
                :key="item.codeKey"
                :label="item.codeValueZh"
                :value="item.codeKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('courseOption.numberLimit')"
            prop="numberLimit"
          >
            <el-input
              v-model="newForm.numberLimit"
              size="reportContentInput"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('courseOption.coursewareLink')">
            <el-input
              v-model="newForm.coursewareLink"
              size="reportContentInput"
              maxlength="500"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="container">
        <el-col :span="20" :offset="2">
          <!-- 简介 -->
          <el-form-item
          :label="$t('courseOption.introduction')"
          class="formItem"
        >
          <el-input
            v-model="newForm.introduction"
            type="textarea"
            size="reportLongContentInput"
            :rows="7"
            maxlength="600"
          ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="foot-container">
      <el-col :span="12">
        <el-button type="submit" @click.native.prevent="handleSubmit">{{
          $t("common.submit")
        }}</el-button>
      </el-col>
      <el-col :span="12">
        <el-button type="return" @click.native.prevent="handleReturn">{{
          $t("common.back")
        }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    var validateMinutes = (rule, value, callback) => {
      // console.log('value',value)
      if (this.days + this.hours + this.minutes == 0) {
        callback(new Error(this.$t("courseOption.pleaseEnterDuration")));
      } else {
        callback();
      }
    };
    return {
      // 课程时长想改成天+小时+分钟---zhc
      // 时分秒
      durationList: [],
      hourList: [],
      dayList: [],
      days: 0,
      hours: 0,
      minutes: 0,
      // 时长校验
      minutesRule: {
        trigger: ["blur", "change"],
        validator: validateMinutes,
        type: "number"
      },
      // 表单数据
      newForm: {
        courseType: "0", // 课程类型：0-公共课程，1-内部课程
        field: "",
        category: "",
        courseNumber: "",
        courseName: "",
        targetStudents: "",
        qualificationRequirements: "",
        form: "",
        classLanguage: "",
        duration: "",
        numberLimit: "",
        certificate: "",
        coursewareLink: "",
        introduction: "",
        videoUrl: "", // 视频地址（内部课程特有）
        videoPassword: "", // 视频密码（内部课程特有）
        createUser: localStorage.getItem("userId")
      },
      // 选择项数据
      selection: [],
      // 重新加载类别的下拉选项
      reloadCategoryFlag: true,
      // 校验规则
      rules: {
        courseType: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectCourseType"),
            trigger: "change"
          }
        ],
        field: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectField"),
            trigger: "change"
          }
        ],
        courseName: [
          {
            required: true,
            message: this.$t("courseOption.pleaseEnterCourseName"),
            trigger: "blur"
          }
        ],
        form: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectForm"),
            trigger: "blur"
          }
        ],
        category: [
          {
            required: true,
            message: this.$t("courseOption.pleaseSelectCategory"),
            trigger: "change"
          }
        ],
        courseNumber: [
          {
            required: true,
            message: this.$t("courseOption.pleaseEnterCourseNumber"),
            trigger: "blur"
          }
        ],
        numberLimit: [
          {
            pattern: /^(0|[1-9][0-9]*)$/,
            message: this.$t("courseOption.pleaseEnterPositiveInteger"),
            trigger: "blur"
          }
        ],
        videoUrl: [
          {
            required: true,
            message: this.$t("courseOption.pleaseEnterVideoUrl"),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    // 初始化
    init() {
      let url = "/api/courseOption/init";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.selection = response.data.data;
            this.newForm.form = "01";
            this.newForm.classLanguage = "001";
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 获取分钟
    getDurationList() {
      for (let i = 0; i < 60; i++) {
        this.durationList.push(i);
      }
    },
    // 获取小时
    getHours() {
      for (let i = 0; i < 12; i++) {
        this.hourList.push(i);
      }
    },
    // 获取天
    getDayList() {
      this.dayList.push(0);
      for (let i = 1; i <= 10; i=i+0.5) {
        this.dayList.push(i);
      }
    },
    // 校验数字
    validateNumber() {
      this.$nextTick(function() {
        if (this.newForm.courseNumber) {
          // this.newForm.courseNumber = this.newForm.courseNumber.replace(
          //   /[\u4E00-\u9FA5]/g,
          //   ""
          // );
          this.newForm.courseNumber = this.newForm.courseNumber.replace(
            /[^\da-zA-Z]/g,
            ""
          );
          // this.newForm.courseNumber = this.newForm.courseNumber.replace(
          //   ".",
          //   ""
          // );
        }
      });
    },
    // 格式化数字
    formatNumber() {
      if (this.newForm.courseNumber.length == 1) {
        this.newForm.courseNumber = "0" + this.newForm.courseNumber;
      }
    },
    // 领域的选中值发生变更的处理
    changeField() {
      // 清空类别下拉框的值
      this.newForm.category = "";
      // 清空类别下拉框的报错信息
      this.$nextTick(function() {
        this.$refs.newFormRef.clearValidate(["category"]);
      });
      // 重新加载类别下拉框的选项
      this.reloadCategoryFlag = false;
      this.reloadCategoryFlag = true;
    },
    // 课程类型变更的处理
    changeCourseType() {
      if (this.newForm.courseType === '1') {
        // 内部课程：固定课程形式为录播（02）
        this.newForm.form = '02';
        // 清空视频相关字段的校验
        this.$nextTick(function() {
          this.$refs.newFormRef.clearValidate(["videoUrl"]);
        });
      } else {
        // 公共课程：重置课程形式为默认值
        this.newForm.form = '01';
        // 清空内部课程特有字段
        this.newForm.videoUrl = '';
        this.newForm.videoPassword = '';
      }
    },
    // // 时间选择器获得焦点时的处理
    // timePickerFocus() {
    //   if (this.newForm.duration == "" || this.newForm.duration == null) {
    //     this.newForm.duration = "00:45";
    //   }
    // },
    // 时间选择器失去焦点时的处理
    // timePickerBlur() {
    //   this.$refs.newFormRef.validateField(["duration"]);
    // },
    // 提交
    handleSubmit() {
      this.$refs["newFormRef"].validate(valid => {
        if (valid) {
          // 内部课程特有字段校验
          if (this.newForm.courseType === '1' && !this.newForm.videoUrl) {
            this.$message.error(this.$t("courseOption.pleaseEnterVideoUrl"));
            return;
          }

          const loading = this.$loading({
            lock: true,
            text: this.$t("common.loading"),
            background: "rgba(255,255,255,0.8)",
            target: document.querySelector("#main-container")
          });
          // 课程时长想改成天+小时+分钟---zhc
          let durations = String(
            Number(this.days * 24 * 60) +
              Number(this.hours * 60) +
              Number(this.minutes)
          );
          let url = "/api/courseOption/submit";
          this.newForm.coursewareLink = this.newForm.coursewareLink.trim();
          this.newForm.videoUrl = this.newForm.videoUrl.trim();
          this.newForm.videoPassword = this.newForm.videoPassword.trim();
          this.newForm.createUser = localStorage.getItem("userId");
          this.newForm.duration = durations;
          this.$http
            .post(url, this.newForm)
            .then(response => {
              if (response.data.code === 200) {
                this.newForm = {
                  courseType: "0",
                  field: "",
                  category: "",
                  courseNumber: "",
                  courseName: "",
                  targetStudents: "",
                  qualificationRequirements: "",
                  form: "01",
                  classLanguage: "001",
                  duration: "",
                  numberLimit: "",
                  certificate: "",
                  coursewareLink: "",
                  introduction: "",
                  videoUrl: "",
                  videoPassword: ""
                };
                this.days = 0;
                this.hours = 0;
                this.minutes = 0;
                this.$nextTick(function() {
                  this.$refs.newFormRef.clearValidate(["field", "category","minutes", "videoUrl"]);
                  // this.$refs.minutesRule.clearValidate();
                });
                loading.close();
                this.$message.success(response.data.data);
              } else {
                loading.close();
                this.$message.error(response.data.message);
              }
            })
            .catch(err => {
              loading.close();
              console.log(err);
              this.$message.error(this.$t("common.anErrorOccurred"));
            });
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.init();
    this.getDurationList();
    this.getHours();
    this.getDayList();
  }
};
</script>

<style lang="scss" scoped>
.foot-container {
  margin: 40px auto 0 auto;
  height: 26px;
  width: 14%;
  text-align: center;
}

// el-form-item的label的行高度
.formItem >>> .el-form-item__label {
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0301.vue